// extracted by mini-css-extract-plugin
export var adjacentNavigationContainer = "AdjacentPostNavigation-module--adjacent-navigation-container--1A-Pm";
export var adjacentNavigation = "AdjacentPostNavigation-module--adjacent-navigation--3GUfM";
export var previous = "AdjacentPostNavigation-module--previous--U97O1";
export var next = "AdjacentPostNavigation-module--next--3wGhI";